<template>
    <h2 class="scroll-m-20 leading-9 text-foreground text-3xl font-semibold tracking-tight transition-colors ">
        <slot/>
    </h2>
</template>